import IPRangeListTargetingApi from '@/api/IPRangeListTargeting'
export class IPRangeListTargetingModel {
  constructor(item) {
    const {
      id,
      ownerProfileId,
      resourceId,
      resourceType,
      resourceName,
      ipRangeCount,
      name,
      description,
      blackOrWhite,
    } = item
    this.id = Number(id) || undefined
    this.ownerProfileId = ownerProfileId || undefined
    this.resourceId = resourceId || undefined
    this.resourceType = resourceType || undefined
    this.resourceName = resourceName || undefined
    this.ipRangeCount = ipRangeCount != null ? Number(ipRangeCount) : undefined
    this.name = name || undefined
    this.description = description || undefined
    this.blackOrWhite = blackOrWhite || undefined
  }
  getListName() {
    return this.name + 'のIP'
  }
  getBlackOrWhite() {
    return this.blackOrWhite === 'black' ? 'ブラック' : 'ホワイト'
  }
  getResourceTypeName() {
    switch (this.resourceType) {
      case 'advertiser':
        return '広告主'
      case 'oem':
        return '共通'
      case 'agency':
        return '代理店'
      case 'insertion_order':
        return '案件'
    }
    return ''
  }
  static async findByOwnerProfileId(params) {
    const ret = await IPRangeListTargetingApi.fetchIPRangeListTargetingList(
      params,
    )
    return ret
  }
  static async findByAdvertiserId(params, advertiserId) {
    const ret = await IPRangeListTargetingApi.fetchIPRangeListTargetingListAdvertiser(
      params,
      advertiserId,
    )
    return ret
  }
}

export class IPRangeListTargetingItemModel {
  constructor(item) {
    const { from, to } = item
    this.from = from || undefined
    this.to = to || undefined
  }
}

export class GetIPRangeListTargetingListForm {
  constructor(item = {}) {
    const { ownerProfileId, pageNo, pageSize } = item
    this.owner_profile_id = ownerProfileId || undefined
    this.page_no = pageNo || undefined
    this.page_size = pageSize || undefined
  }
}

// 20190522 一旦作らないことになっている
export class GetIPRangeListTargetingItemForm {
  constructor(item = {}) {
    const { systemOwnerId, pageNo, pageSize } = item
    this.system_owner_id = Number(systemOwnerId) || undefined
    this.page_no = pageNo || undefined
    this.page_size = pageSize || undefined
  }
}
